<template>
  <button
    :data-bs-toggle="dataToggle"
    :href="dataTarget ? '#' + dataTarget : ''"
    :data-bs-dismiss="dataDismiss"
    :aria-controls-="ariaControls"
    :aria-label="ariaLabel"
    :aria-expanded="ariaExpanded"
    :type="type"
    :disabled="disabled"
    :class="color ? 'btn-' + color : ''"
    class="base-button font-custom rounded-pill"
    @click="$emit('click-base-button-event-emitter')"
  >
    {{ label }}
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: undefined
    },
    dataToggle:{
      type: String,
      default: undefined
    },
    dataTarget: {
      type: String,
      default: undefined
    },
    dataDismiss: {
      type: String,
      default: undefined
    },
    ariaControls: {
      type: String,
      default: undefined
    },
    ariaLabel: {
      type: String,
      default: undefined
    },
    ariaExpanded: Boolean,
    type: {
      default: 'button',
      type: String
    },
    disabled: {
      default: false,
      type: Boolean
    },
    color: {
      default: '',
      type: String
    }
  },
  emits: ['click-base-button-event-emitter']
}
</script>

<style scoped lang="scss">

.base-button {
  @extend .btn;
  max-width: 100%;
}
</style>
